import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const Title = styled.h1`
  width: calc(100% - 60px);
  margin: 13px 0 16px;
  ${TYPOGRAPHY.title}

  svg {
    transform: translateY(-2px);
  }
`;

export default Title;
